/**
 * Normalize `form_filled created` / `form_filled updated` socket payloads.
 */
import {
  SERVICE_INTAKE_FORM_ID
} from '../../constants/fieldOperations'
import { USER_ROLES } from '../ac/constants'
import { canAccessDeviceForView } from '../ac/recordAccess'

export const normalizeFormFilledSocketPayload = payload => {
  if (payload == null) return null
  let body = payload
  if (Array.isArray(body)) {
    body = body.length > 1 ? body[1] : body[0]
  }
  if (body?.form_filled_id) return body
  if (body?.data?.form_filled_id) return body.data
  return body
}

export const isRootServiceIntake = filled => (
  filled?.form_id === SERVICE_INTAKE_FORM_ID &&
  (filled.parent == null || filled.parent === '')
)

export const shouldRefreshActiveServicesList = filled => {
  if (!filled) return false
  if (isRootServiceIntake(filled)) return true
  return filled.parent == null || filled.parent === ''
}

export const resolveFieldOperationServiceId = filled => {
  if (!filled) return null
  if (filled.field_operation_service_id) return String(filled.field_operation_service_id)
  return null
}

export const shouldOpenPriseDeServiceDialog = filled => {
  const serviceId = resolveFieldOperationServiceId(filled)
  if (!serviceId) return false
  if (filled.open_prise_de_service === true) return true
  return isRootServiceIntake(filled)
}

/**
 * Client role: only show the service intake popup when the submitting device is
 * in the viewer's assigned devices (profile.deviceIds). Other roles unchanged.
 */
export const canViewerOpenPriseDeServiceDialog = (profile, filled) => {
  if (!shouldOpenPriseDeServiceDialog(filled)) return false
  if (!profile) return false

  if (profile.roleId !== USER_ROLES.CLIENT) {
    return true
  }

  const deviceId = filled.id_device ?? filled.idDevice ?? filled.device_id
  if (deviceId == null || deviceId === '') return false

  return canAccessDeviceForView(profile, deviceId)
}
